import { useTranslation } from '@sib/i18n';
import { EntityCommentsList } from '@sidecar/common/components/DetailsModal';
import { TaskCommentCard } from './TaskCommentCard';
import { useTaskCommentsList } from './TaskCommentsList.utils';

interface TaskCommentsListProps {
  taskId: string;
}

export const TaskCommentsList = ({ taskId }: TaskCommentsListProps) => {
  const { t } = useTranslation();
  const {
    comments,
    sentryRef,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isPending,
  } = useTaskCommentsList(taskId);

  return (
    <EntityCommentsList
      isLoading={isLoading}
      isPending={isPending}
      isEmpty={comments.length === 0}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      sentryRef={sentryRef}
      emptyLabel={t('components.taskDetails.comments.emptyList')}
    >
      {comments.map(comment => (
        <TaskCommentCard key={`task-comment-${comment.id}`} comment={comment} />
      ))}
    </EntityCommentsList>
  );
};
